import styled from 'styled-components';
import font from '../../styles/font';

export const StyledContainer = styled.div`
  height: 100vh;
  width: 100%;
  padding: 1.6rem;
  margin-top: 11rem;
  margin-bottom: 6rem;
`;

export const ProfileWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Margin = styled.div`
  height: 3.2rem;
`;

export const Text = styled.div`
  ${font.medium_14}
`;
